<template>
  <div>
    <div style="min-height: 400px; height: 400px; position: relative;">
      <GoogleMap :showlayers="false" ref="map" @click="handleMapClick" :showMapTypeToggle="true" mapTypeTogglePlacement="bottom">
        <template v-slot:body>
          <div style="pointer-events: all; position: absolute; top: 10px; left: 10px; z-index: 1000; display: flex; gap: 10px; flex-direction: column;">
            <button
              v-if="!editMode"
              class="btn btn-primary"
              @click="startEdit"
              style="cursor: pointer"
            >
              Editar
            </button>
            <div v-if="editMode" style="display: flex; flex-direction: column; gap: 10px; background: white; padding: 10px; border-radius: 5px; box-shadow: 0 2px 6px rgba(0,0,0,0.3);">
              <div style="display: flex; align-items: center; gap: 10px;">
                <label style="margin: 0; font-size: 14px; font-weight: 500;">Cor do Pin:</label>
                <input
                  type="color"
                  v-model="editingColor"
                  @input="updatePinColor"
                  @change="updatePinColor"
                  style="width: 50px; height: 35px; border: 1px solid #ccc; border-radius: 4px; cursor: pointer;"
                />
              </div>
              <div style="font-size: 12px; color: #666;">
                Clique no mapa para ajustar a posição
              </div>
              <div style="display: flex; gap: 5px;">
                <button
                  class="btn btn-success btn-sm"
                  @click="saveEdit"
                  style="cursor: pointer; flex: 1;"
                >
                  Salvar
                </button>
                <button
                  class="btn btn-secondary btn-sm"
                  @click="cancelEdit"
                  style="cursor: pointer; flex: 1;"
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </template>
      </GoogleMap>
    </div>
  </div>
</template>
<script>
import GoogleMap from "./mapa/GoogleMap.vue";
export default {
  props: ["local", "types", "value"],
  components: {
    GoogleMap,
  },
  // Fornecido pelo Crud: avisa que o pin está em edição, para o Salvar do form
  // perguntar se aplica ou descarta em vez de descartar sem avisar.
  inject: {
    crudPendingGuard: { default: null },
  },
  data() {
    return {
      editMode: false,
      editingColor: '#006035',
      type: "ponto",
      values: {
        ponto: { latitude: null, longitude: null, cor: '#006035' },
        area: { latitude: null, longitude: null, area: [], cor: '#006035' },
      },
      originalValues: null,
      btntypes: [
        {
          title: "Ponto",
          icon: "fa fa-location-dot",
          value: "ponto",
        },
        {
          title: "Area",
          icon: "fa fa-map-location-dot",
          value: "area",
        },
      ],
    };
  },
  methods: {
    startEdit() {
      this.editMode = true;
      // Salvar valores originais para poder cancelar
      this.originalValues = JSON.parse(JSON.stringify(this.values));
      this.editingColor = this.values.ponto.cor || '#006035';

      // Mudar para visualização satélite no modo de edição
      if (this.$refs.map && this.$refs.map.map) {
        this.$refs.map.map.setMapTypeId('hybrid');
      }
    },
    cancelEdit() {
      this.editMode = false;
      // Restaurar valores originais
      if (this.originalValues) {
        this.values = JSON.parse(JSON.stringify(this.originalValues));
      }
      this.updateMapPrin();

      // Voltar para visualização híbrida
      if (this.$refs.map && this.$refs.map.map) {
        this.$refs.map.map.setMapTypeId('hybrid');
      }
    },
    saveEdit() {
      this.editMode = false;
      var value = null;
      switch (this.type) {
        case "ponto": {
          value = this.values.ponto;
          value.tipo = "PONTO";
          break;
        }
        case "area": {
          value = this.values.area;
          value.tipo = "AREA";
          if (value.area.length < 3) {
            value = null;
          }
          break;
        }
      }
      this.$emit("value", value);
      this.updateMapPrin();
    },
    updatePinColor() {
      // Atualizar a cor no objeto de valores
      this.values.ponto.cor = this.editingColor;
      this.values.area.cor = this.editingColor;
      // Atualizar o mapa
      this.updateMapPrin();
    },
    getTypes() {
      if (this.types == null) {
        return this.btntypes;
      } else {
        var ty = [];
        for (const tp of this.types) {
          for (const t of this.btntypes) {
            if (tp == t.value) {
              ty.push(t);
            }
          }
        }
        return ty;
      }
    },
    handleMapClick(e) {
      if (this.editMode) {
        this.clickMap(e);
      }
    },
    clickMap(e) {
      if (e.latlng) {
        switch (this.type) {
          case "ponto": {
            this.values.ponto.latitude = e.latlng.lat;
            this.values.ponto.longitude = e.latlng.lng;
            break;
          }
          case "area": {
            this.values.area.area.push({
              latitude: e.latlng.lat,
              longitude: e.latlng.lng,
            });
            var lat = 0;
            var lng = 0;
            for (const a of this.values.area.area) {
              lat += a.latitude;
              lng += a.longitude;
            }
            this.values.area.latitude = lat / this.values.area.area.length;
            this.values.area.longitude = lng / this.values.area.area.length;
            break;
          }
        }
        // Forçar atualização imediata
        this.$nextTick(() => {
          this.updateMapPrin();
        });
      }
    },
    updateMapPrin() {
      var point = null;
      switch (this.type) {
        case "ponto": {
          point = this.values.ponto;
          break;
        }
        case "area": {
          point = this.values.area;
          break;
        }
      }

      if (point && this.$refs.map) {
        this.$refs.map.addPoints([point]);
        this.$refs.map.move(
          point.latitude,
          point.longitude,
          this.$refs.map.getZoom()
        );

        // Atualizar polígono se for área
        if (this.type === 'area' && point.area && point.area.length > 0) {
          this.$refs.map.setPolygonPath(point.area);
        }
      }
    },
    add(point, markerGroup, map) {
      if (!point.area) {
        // Adicionar marcador simples com a cor do pin
        const pinColor = point.cor || '#006035'; // Usar cor do pin ou cor padrão
        const htmlIcon = `<div class="pin-marker-edit" style="background: ${pinColor}; border-color: ${pinColor};"></div>`;

        map.addMarkerWithDivIcon(
          point.latitude,
          point.longitude,
          htmlIcon
        );
      } else {
        // Adicionar polígono
        if (point.area.length > 0) {
          map.setPolygonPath(point.area);
        }
      }
    },
  },
  beforeUnmount() {
    if (this.crudPendingGuard && this.pendingGuard) {
      this.crudPendingGuard.unregister(this.pendingGuard);
    }
  },
  mounted() {
    if (this.crudPendingGuard) {
      this.pendingGuard = {
        message: "O local do pin está em edição e ainda não foi salvo. Deseja salvar as alterações do pin ou descartá-las?",
        hasPending: () => this.editMode,
        save: () => this.saveEdit(),
        discard: () => this.cancelEdit(),
      };
      this.crudPendingGuard.register(this.pendingGuard);
    }

    this.$refs.map.event = {
      add: this.add,
    };

    // Aguardar o mapa carregar completamente
    const waitForMap = () => {
      if (this.$refs.map && this.$refs.map.map && this.$refs.map.isLoaded) {
        // Mudar para visualização satélite
        this.$refs.map.map.setMapTypeId('hybrid');

        // Carregar dados do value se existir
        if (this.value) {
          this.values.ponto.latitude = this.value.latitude;
          this.values.ponto.longitude = this.value.longitude;
          this.values.ponto.cor = this.value.cor || '#006035';
          this.values.area.latitude = this.value.latitude;
          this.values.area.longitude = this.value.longitude;
          this.values.area.cor = this.value.cor || '#006035';

          this.editingColor = this.value.cor || '#006035';

          if (this.value.area) {
            this.values.area.area = this.value.area;
            this.type = "area";
          }

          this.$nextTick(() => {
            this.updateMapPrin();
          });
        }
      } else {
        // Mapa ainda não carregou, tentar novamente
        setTimeout(waitForMap, 100);
      }
    };

    setTimeout(waitForMap, 100);
  },
  watch: {
    type(t) {
      this.updateMapPrin();
    },
    value: {
      handler(newValue) {
        if (newValue && this.$refs.map && this.$refs.map.isLoaded) {
          this.values.ponto.latitude = newValue.latitude;
          this.values.ponto.longitude = newValue.longitude;
          this.values.ponto.cor = newValue.cor || '#006035';
          this.values.area.latitude = newValue.latitude;
          this.values.area.longitude = newValue.longitude;
          this.values.area.cor = newValue.cor || '#006035';

          this.editingColor = newValue.cor || '#006035';

          if (newValue.area) {
            this.values.area.area = newValue.area;
            this.type = "area";
          }

          this.$nextTick(() => {
            this.updateMapPrin();
          });
        }
      },
      deep: true
    }
  },
};
</script>

<style>
.pin-marker-edit {
  /* Set the marker size here */
  width: 30px;
  height: 30px;
  border-radius: 2rem;
  /* Set the marker color here */
  background: #006035;

  display: inline-block;
  border-bottom-right-radius: 0;
  position: absolute;
  transform: rotate(45deg);

  /* optional fanciness */
  border: 1px solid #006035;
  margin-top: -30px;
  margin-left: -9px;
}
/* inner circle (optional if you don't need the central dot) */
.pin-marker-edit::before {
  content: "";
  background: white;
  width: 50%;
  height: 50%;
  border-radius: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  /* optional fanciness */
  box-shadow: 0.1rem 0.1rem 0.2rem 0.1rem rgba(0, 0, 0, 0.1);
}
/* shadow (optional if you don't need a shadow) */
.pin-marker-edit::after {
  content: "";
  background: rgba(128, 128, 128, 0.2);
  width: 75%;
  height: 75%;
  border-radius: 100%;
  position: absolute;
  top: 100%;
  left: 100%;
  transform: translate(-50%, -50%) rotate(45deg) scaleX(0.5);
}
</style>
